import { IVersionInfo } from './core/models/IVersionInfo';

export class KazamVersionInfo implements IVersionInfo {
  name = process.env.REACT_APP_NAME || "Kazam";
  version = process.env.REACT_APP_VERSION || "1.5.1";
  build = process.env.REACT_APP_BUILD || "2070";
  baseUrl = process.env.REACT_APP_BASE_URL || "@BASE_URL";
  target = process.env.REACT_APP_TARGET || "prod";
  hash = process.env.REACT_APP_HASH || "ae22b0314a9b489459d663223842e5b6de963571";
  branch = process.env.REACT_APP_BRANCH || "release/v2-11";

  public toString(): string {
    return `${this.name} ${this.version} b${this.build}`;
  }
}

export const VersionInfo = new KazamVersionInfo();
